import React, { useEffect, useRef, useState } from 'react';
import { FilterButtonGroup, FilterButton } from '@td-client-frontend/common';
import Search from '../../../components/EmployerGroupSearch/Search';
import List, { NoResultsDialog } from '../../../components/List';
import ListItem from '../../../components/ListItem';
import { SideMenu } from '../../../components/SideMenu';
import { useGroupContext } from '../../../context/GroupContext';
import useGroupList from '../../../hooks/useGroupList';
import WithPermission, { PermMode } from '../../../components/WithPermission';
import { GroupType } from '../../../api/api';
import { Td } from '../../../components/Td';

const HEADERS: string[] = ['Employers', 'Group Number'];

export const SideMenuContent = ({ handleShowGroupModal }) => {
  const loadMoreRef = useRef<HTMLSpanElement>(null);
  const [search, setSearchString] = useState<string>('');

  const { type = GroupType.ACTIVE, groupId, onGroupSelect, onTypeChange } = useGroupContext();
  const { status, canFetchMore, isFetchingMore, values } = useGroupList({ type, search, loadMoreRef });

  useEffect(() => {
    if (values?.length) {
      const { _id, name } = values[0];
      onGroupSelect({ name, id: _id });
    }
  }, [values, onGroupSelect]);

  return (
    <SideMenu>
      <FilterButtonGroup>
        <WithPermission requiredPerms={['GroupRead']} mode={PermMode.ANY}>
          <>
            <FilterButton
              label="Active"
              value={GroupType.ACTIVE}
              onClick={onTypeChange}
              isSelected={GroupType.ACTIVE === type}
            />
            <FilterButton
              label="Inactive"
              value={GroupType.INACTIVE}
              onClick={onTypeChange}
              isSelected={GroupType.INACTIVE === type}
            />
          </>
        </WithPermission>
        <WithPermission requiredPerms={['DraftRead']} mode={PermMode.ANY}>
          <FilterButton
            label="Drafts"
            value={GroupType.DRAFT}
            onClick={onTypeChange}
            isSelected={GroupType.DRAFT === type}
          />
        </WithPermission>
      </FilterButtonGroup>
      <Search onSearch={setSearchString} loading={status === 'loading'} />
      <List title="Groups search result table" headers={HEADERS} loading={status === 'loading'}>
        {groupId &&
          values.map(({ name, planNumber, _id }) => {
            return (
              <ListItem _id={_id} key={_id} selected={groupId} onClick={() => onGroupSelect({ name, id: _id })}>
                <Td>{name}</Td>
                <Td>{planNumber}</Td>
              </ListItem>
            );
          })}
        {values?.length > 0 && type === GroupType.DRAFT && (
          <tr>
            <td colSpan={2} className="py-4 text-center font-effra">
              <span ref={loadMoreRef} className="my-4">
                {isFetchingMore ? 'Loading more...' : canFetchMore ? 'Load More' : 'Nothing more to load'}
              </span>
            </td>
          </tr>
        )}
        {!values?.length && (
          <WithPermission requiredPerms={['GroupCreate', 'DraftCreate']} mode={PermMode.ANY}>
            <NoResultsDialog
              headers={HEADERS}
              newEntryLabel="New group"
              noResultAction={handleShowGroupModal}
              noResultsLabel="No results found. Please try another search or add a new group"
              permissionsForButton={['GroupCreate', 'DraftCreate']}
            />
          </WithPermission>
        )}
      </List>
    </SideMenu>
  );
};
